import { TourOutputWithOutStatus } from './tour-output-with-out-status.model';


export class TourSelectByIdOutput implements ITourSelectByIdOutput {
    status!: number;
    message!: string;
    data!: TourOutputWithOutStatus;

    constructor(data?: ITourSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? TourOutputWithOutStatus.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TourSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new TourSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ITourSelectByIdOutput {
    status: number;
    message: string;
    data: TourOutputWithOutStatus;
}

